import LoginLanding from '@shared/components/user/LoginLanding';
import { getEnabledClientId } from '@shared/constants/Keys';
import { getAuthRedirectUri, getBaseApiUrl } from '@shared/constants/Urls';
import AuthContainer from '@shared/hooks/state/AuthContainer';
import CurrentUserContainer from '@shared/hooks/state/CurrentUserContainer';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';

export default function LoginPage() {
    const currentUserContainer = CurrentUserContainer.useContainer();
    const authContainer = AuthContainer.useContainer();
    const navigate = useNavigate();
    const [queryParams] = useSearchParams();

    useEffect(() => {
        const queryCode = queryParams.get('code');
        if (queryCode) {
            navigate(`../authcallback?code=${queryCode}`);
        }
        if (authContainer.isAuthenticatedRef.current == true) {
            navigate('../');
        }
    }, []);

    const signInUrl = `${getBaseApiUrl()}/signin?client_id=${getEnabledClientId()}&redirect_uri=${getAuthRedirectUri()}`;
    const signUpUrl = `${getBaseApiUrl()}/signup/v2?client_id=${getEnabledClientId()}&redirect_uri=${getAuthRedirectUri()}&culture=${currentUserContainer.userLocalePreferencesRef.current.defaultLocale}`;

    return <>{!authContainer.isAuthenticated && <LoginLanding signInUrl={signInUrl} signUpUrl={signUpUrl} />}</>;
}
